enum AboutTabItem {
  INDEX = 'index',
  FAQ = 'faq',
  COB = 'cob',
  BS = 'bs',
}

export { AboutTabItem };
